const MODE_PRODUCTION_COMPLETEDATA = {
    name: "PRODUCTION_COMPLETEDATA",
    protocol: "https",
    ip: "plattform.ddr-literatur.de",
    port: "443",
    routing_context: "/exploration-api",
    events_resource: "csv-events",
    publications_resource: "csv-publications",
    auth: true
}

const MODE_PRODUCTION_ANONYMISED = {
    name: "PRODUCTION_ANONYMISED",
    protocol: "https",
    ip: "plattform.ddr-literatur.de",
    port: "443",
    routing_context: "/exploration-api",
    events_resource: "csv-events-public",
    publications_resource: "csv-publications-public",
    auth: false
}

const MODE_LOCALDEV = {
    name: "LOCALDEV",
    protocol: "http",
    ip: "localhost",
    port: "8396",
    events_resource: "csv-events",
    publications_resource: "csv-publications",
    auth: false
}

const MODE_LOCALDEV_ANONYMISED = {
    name: "LOCALDEV",
    protocol: "http",
    ip: "localhost",
    port: "8396",
    events_resource: "csv-events-public",
    publications_resource: "csv-publications-public",
    auth: false
}


console.log("modes: ", MODE_LOCALDEV, MODE_PRODUCTION_COMPLETEDATA, MODE_PRODUCTION_ANONYMISED,MODE_LOCALDEV_ANONYMISED);

const DEPLOYMENT_MODE = MODE_PRODUCTION_ANONYMISED;

export const EVENTS_RESOURCE = "events_resource";
export const PUBLICATIONS_RESOURCE = "publications_resource";

export function getApiAccessUrl(resource,token) {
    const url = DEPLOYMENT_MODE.protocol
    + "://"
    + DEPLOYMENT_MODE.ip
    + ":"
    + DEPLOYMENT_MODE.port
    + (DEPLOYMENT_MODE.routing_context || "")
    + "/api/"
    + DEPLOYMENT_MODE[resource]
    + (DEPLOYMENT_MODE.auth ? "?token=" + token : "");

    console.log("created api access url: ", url);

    return url;
}

